// @ts-nocheck
import { Block, Carousel } from '@xprog/prensa'
import { PageBlockTypes as p } from '@xprog/prensa/types'
import IconButton from 'components/Buttons/IconButton.index'
import chunk from 'lodash/chunk'
import map from 'lodash/map'

import { teasers as T } from '../teasers'
import { addRelativeWidthToTeaser } from './utils'

const TeaserColumnist = addRelativeWidthToTeaser(T.TeaserColumnist, '100%')

const renderSlotMobileWrapComponent = (data) => {
  return (
    <Carousel
      axis='horizontal'
      css={{
        carousel: {
          width: '100%'
        },
        container: {
          width: '100%'
        },
        root: {
          width: '100%',
        },
        controlDots: {
          mt: '$2',
          mb: '$0',
        },
        controlDotsDot: {
          background: '#c4c4c4',
          boxShadow: 'none',
          height: '8px',
          width: '8px',
          opacity: '1',
          '&.selected': { background: 'black' }
        }
      }}
      labels={{
        item: '',
        leftArrow: 'Retroceder',
        rightArrow: 'Avançar'
      }}
      showArrows={false}
    >
      {data}
    </Carousel>
  )
}

const renderSlotDesktopWrapComponent = (data) => {
  return (
    <Carousel
      axis='horizontal'
      css={{
        carousel: {
          width: '100%'
        },
        container: {
          width: '100%'
        },
        root: {
          width: '100%',
          '.carousel .slider-wrapper': {
            width: 'calc(100% - 64px)'
          }
        },
        controlDots: {
          mt: '$2',
          mb: '$0',
        },
        controlDotsDot: {
          background: '#c4c4c4',
          boxShadow: 'none',
          height: '8px',
          width: '8px',
          opacity: '1',
          '&.selected': { background: 'black' }
        }
      }}
      renderArrowNext={(onClick, hasArrow) => {
        return hasArrow && (
          <IconButton
            variant='ghost'
            onClick={onClick}
            icon={{
              alt: '',
              height: '16px',
              src: '/assets/opopular/icons/IcAvancarCinza.svg',
              width: '16px'
            }}
            css={{
              button: {
                position: 'absolute',
                top: 'calc(50% - 20px)',
                right: '0px'
              }
            }}
          />
        )
      }}
      renderArrowPrev={(onClick, hasArrow) => {
        return hasArrow && (
          <IconButton
            variant='ghost'
            onClick={onClick}
            icon={{
              alt: '',
              height: '16px',
              src: '/assets/opopular/icons/IcVoltarCinza.svg',
              width: '16px'
            }}
            css={{
              button: {
                position: 'absolute',
                bottom: 'calc(50% - 10px)',
                left: '0px'
              }
            }}
          />
        )
      }}
      labels={{
        item: '',
        leftArrow: 'Retroceder',
        rightArrow: 'Avançar'
      }}
    >
      {map(chunk(data, 4), (items, key) => (
        <Block
          css={{ align: ['row', 'left', 'middle'], width: 'auto' }}
          key={key}
        >
          {map(items, (item, key) => (
            <Block
              css={{ align: ['row', 'left', 'middle'], width: 'auto' }}
              key={key}
            >
              {item}
            </Block>            
          ))}
        </Block>
      ))}
    </Carousel>
  )
}

export const LayoutColumnist: p.SlotConfigProps = {
  wrapperContent: {
    enabled: true,
    component: renderSlotMobileWrapComponent
  },
  css: {
    column: {
      align: ['row', 'center', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnContent': {
        pt: '$3',
        pb: '$5',
        maxWidth: 'calc(100% - $2)'
      },
      '.ColumnBottom': {
        display: 'none'
      }
    },
    item: {
      width: '100%'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        default: [TeaserColumnist, TeaserColumnist]
      },
      slotCenter: {
        default: [TeaserColumnist, TeaserColumnist]
      }
    },
    TemplateColumnist: {
      slotLeft: {
        default: [TeaserColumnist, TeaserColumnist]
      },
      slotCenter: {
        default: [TeaserColumnist, TeaserColumnist]
      }
    }
  }
}

export const LayoutColumnistDesktop: p.SlotConfigProps = {
  wrapperContent: {
    enabled: true,
    component: renderSlotDesktopWrapComponent
  },
  css: {
    column: {
      align: ['row', 'center', 'top'],
      width: '100%',
      '.pds-Carousel-container': {
        width: '100%'
      },
      '.ColumnTop': {
        display: 'none'
      },
      '.ColumnContent': {
        py: '$6',
        maxWidth: 'calc(100% - 180px)'
      },
      '.ColumnBottom': {
        display: 'none'
      }
    },
    item: {
      width: 'calc(100% - $12)'
    }
  },
  slotConfig: {
    Template100: {
      slotLeft: {
        default: [TeaserColumnist, TeaserColumnist]
      },
      slotCenter: {
        default: [TeaserColumnist, TeaserColumnist]
      }
    },
    TemplateColumnist: {
      slotLeft: {
        default: [TeaserColumnist, TeaserColumnist]
      },
      slotCenter: {
        default: [TeaserColumnist, TeaserColumnist]
      }
    }
  }
}
